module.exports = __webpack_public_path__ + "img/2012.10.186946b7.png";